import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Input, Button, message } from "antd";
import { apiPutCarts } from "api/api";
import { InputPassword, InputPlug } from "./style";
import {
  useOutletContext,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { apiLogIn, apiGetOtp } from "api/api";
import { useTranslation } from "react-i18next";
import { errorHandler } from "utility/functions/errorHandler";
import { useDispatch } from "react-redux";
import { setIsChartOpen } from "store/slice/index";
import { getSafeRedirect } from "utility/functions/redirect";

const LogIn = () => {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();

  const [info, success, warning, error] = useOutletContext(); // 從outlet傳過來的, 必須整個陣列帶入
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const fromRegister = searchParams.get("fromRegister");

  const [isLoading, setIsLoading] = useState(false);
  const [isForgetLoading, setIsForgetLoading] = useState(false);

  const redirect = getSafeRedirect(searchParams.get("redirect"));

  const fetchLogIn = async (data) => {
    setIsLoading(true);
    try {
      const res = await apiLogIn(data);
      const { token } = res.data.content;
      sessionStorage._skyFilm_t = token; // 先存 token
      message.success("登入成功");

      // 清除註冊流程的 sessionStorage
      sessionStorage.removeItem("r_key");
      sessionStorage.removeItem("r_info");

      // 這裡才可以呼叫 apiPutCarts，這時已經有 token
      // 只合併「活動票券」，購物車不接受其他來源的商品（例如點數方案是獨立訂單）
      const localCarts = (
        JSON.parse(localStorage.getItem("carts")) || []
      ).filter((cart) => cart?.sourceId && cart?.activityId);
      const isLogin =
        sessionStorage._skyFilm_t && sessionStorage._skyFilm_t.length > 0;
      if (localCarts.length > 0 && isLogin) {
        await apiPutCarts(localCarts);
      }
      localStorage.removeItem("carts");

      // 判斷是否要自動開啟購物車
      const params = new URLSearchParams(window.location.search);
      if (params.get("fromCart") === "1") {
        setTimeout(() => {
          dispatch(setIsChartOpen(true)); // 觸發購物車開啟
          // window.dispatchEvent(new Event("openCart"));
        }, 500);
      }

      checkNavigate();
    } catch (error) {
      errorHandler(error, t);
    } finally {
      setIsLoading(false);
    }
  };

  const checkNavigate = () => {
    const fillIndex = searchParams.get("fillIndex");
    const fillKey = searchParams.get("fillKey");
    if (redirect) {
      // 如果有 fillIndex 和 fillKey，要一起帶回去
      let url = redirect;
      const params = [];
      if (fillIndex !== null) params.push(`fillIndex=${fillIndex}`);
      if (fillKey !== null) params.push(`fillKey=${fillKey}`);
      if (params.length > 0) url += `?${params.join("&")}`;
      navigate(url, { replace: true });
    } else {
      // 沒有 redirect 時，直接導回首頁
      navigate("/home", { replace: true });
    }
  };

  const forgetPsd = async () => {
    setIsForgetLoading(true);
    const email = form.getFieldValue("email");
    try {
      // 改善 email 檢查：確保 email 存在且不為空字串
      if (email && email.trim().length > 0) {
        const res = await apiGetOtp({ email: email.trim() });
        const { content } = res.data;
        message.success("已經發送驗證碼至您的信箱");
        sessionStorage.k = content;
        setTimeout(() => {
          navigate("/confirm-otp");
        }, 1500);
      } else {
        message.error("請先輸入email");
      }
    } catch (error) {
      errorHandler(error, t);
    } finally {
      setIsForgetLoading(false);
    }
  };

  const onFinish = (values) => {
    // localStorage.isLogin = true;
    fetchLogIn(values);

    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    error();
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    if (sessionStorage._skyFilm_t) {
      // 只在真的已登入時才導頁
      const params = new URLSearchParams(window.location.search);
      // 這邊判斷來的時候是否有帶 redirect, 如果有的話就轉導回去那一頁, 沒有的話到首頁
      const redirect = getSafeRedirect(params.get("redirect")) || "/home";
      navigate(redirect, { replace: true });
      if (params.get("fromCart") === "1") {
        setTimeout(() => {
          dispatch(setIsChartOpen(true)); // 觸發購物車開啟
        }, 500);
      }
    }
  }, []);

  return (
    <Row className="min-h-[72vh]">
      <Col
        lg={{ span: 8, offset: 8 }}
        sm={{ span: 14, offset: 5 }}
        xs={{ span: 24 }}
        className="pt-10 px-2 md:px-0"
      >
        <Card
          title={<h4 className="text-left">{t("common.logIn")}</h4>}
          className="rounded-2xl px-5 mobile:[&_.ant-card-head-wrapper]:block"
          extra={
            <p className="mobile:mb-4">
              {t("logIn.isUser")}?
              <a
                href={
                  redirect
                    ? `/register?fromRegister=true&redirect=${encodeURIComponent(
                        redirect,
                      )}`
                    : "/register?fromRegister=true"
                }
                className="text-SKF-Blue-001 ml-1"
              >
                這邊註冊Sign up
              </a>
            </p>
          }
        >
          <Form
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
            form={form}
          >
            <Form.Item
              label="Email"
              name="email"
              placeholder="Email"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputPlug size="large" />
            </Form.Item>

            <Form.Item
              label="密碼 Password"
              name="password"
              placeholder="密碼 Password"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputPassword size="large" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="bg-SKF-B-001 w-full"
                loading={isLoading}
              >
                {t("common.logIn")}
              </Button>
            </Form.Item>
            <p className="text-SKF-Blue-001 text-left">
              <Button
                type="link"
                onClick={forgetPsd}
                className="mobile:p-0 pl-0 text-left text-SKF-Blue-001"
                loading={isForgetLoading}
                disabled={isForgetLoading}
              >
                忘記你的密碼？Forgot your password?
              </Button>
            </p>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default LogIn;
